export enum AppView {
  HOME = 'home',
  CREATE = 'create',
  EDITOR = 'editor',
  LIBRARY = 'library',
  WORKFLOWS = 'workflows',
  USAGE = 'usage',
  BILLING = 'billing',
  SETTINGS = 'settings',
  PROFILE = 'profile'
}

export enum WizardStep {
  GOAL = 1,
  CHARACTER = 2,
  SCENE = 3,
  MOTION = 4,
  SOUND = 5,
  FINISH = 6
}

// V2: Subway Builder steps for Cinema Project path
export enum CinemaStep {
  HERO = 1,      // Create character
  LOCATION = 2,  // Create scene/background
  KEYFRAME = 3,  // Combine hero + location
  ANIMATE = 4,   // I2V / Fun Camera
  EXTEND = 5,    // Continue or finish
  AUDIO = 6      // Sound (future)
}

// V2: Project modes
export enum ProjectMode {
  QUICK = 'quick',   // Fast clip (3-10 sec)
  CINEMA = 'cinema'  // Long video with consistent character
}

// V2: Quick clip source type
export enum QuickSource {
  TEXT = 'text',   // T2V
  IMAGE = 'image', // I2V
  VIDEO = 'video'  // VACE
}

// V2: Workflow types matching backend
export enum WorkflowType {
  T2V = 't2v',
  I2V = 'i2v',
  VACE = 'vace',
  FUN_CAMERA = 'fun_camera',
  QWEN_IMAGE = 'qwen_image_2512',
  QWEN_EDIT = 'qwen_image_edit',
  CHARACTER_SHEET = 'character_sheet',
  TURBOVISION = 'turbovision'
}

// V2: Camera pose options for fun_camera
export enum CameraPose {
  STATIC = 'Static',
  ZOOM_IN = 'Zoom In',
  ZOOM_OUT = 'Zoom Out',
  PAN_LEFT = 'Pan Left',
  PAN_RIGHT = 'Pan Right',
  TILT_UP = 'Tilt Up',
  TILT_DOWN = 'Tilt Down',
  ORBIT_LEFT = 'Orbit Left',
  ORBIT_RIGHT = 'Orbit Right'
}

export enum GenerationMode {
  T2I = 'T2I',
  I2V = 'I2V',
  V2V = 'V2V'
}

export interface GenerationTask {
  id: string;
  thumbnail: string;
  status: 'queued' | 'running' | 'completed' | 'failed';
  type: string;
  prompt: string;
  progress?: number;
  cost: number;
  createdAt: string;
}

export interface CharacterPack {
  id: string;
  name: string;
  image: string;
  triggerWord: string;
  loraWeight: number;
  tags: string[];
}

export interface StylePreset {
  id: string;
  name: string;
  thumbnail: string;
  description: string;
}

export interface MotionRef {
  id: string;
  name: string;
  thumbnail: string;
  duration: string;
  cameraMovement: string;
}

export interface WorkflowTemplate {
  id: string;
  name: string;
  description: string;
  tags: string[];
  complexity: 'Simple' | 'Advanced';
  version: string;
}

export interface AIModel {
  id: string;
  name: string;
  type: 'Checkpoint' | 'LoRA' | 'VAE';
  license: 'MIT' | 'CreativeML' | 'Commercial';
  size: string;
}
